import { asyncEmit } from '@/utils/socket';
import { useAmountMemoryStore } from '~/stores/cansino/amountMemory';
/**
 * 牛牛游戏参数接口
 */
export interface NiuniuJoinParams {
    hallName: string;
    rateType: string;
}

/**
 * 牛牛玩家列表参数接口
 */
export interface NiuniuUserListParams {
    hallName: string;
}

/**
 * 牛牛游戏下注参数接口
 */
export interface NiuniuBetParams {
    hallName: string; //大厅名称
    rateType: string; //倍率类
    amount: number;// 下注金额
    sector: string //下注区域索引 对应天、地、玄、黄、
}

/**
 * 牛牛游戏取消下注参数接口
 */
export interface NiuniuCancelBetParams {
    areaIndex: number;  // 要取消的下注区域
    roomId?: string;    // 房间ID，可选
    betId?: string;     // 下注ID，可选，如果提供则仅取消特定下注
}

/**
 * 牛牛游戏状态接口
 */
export interface NiuniuGameState {
    name: string; // 游戏状态名称，如 "PREPARING_NEXT_ROUND"
    end: number;  // 当前状态结束时间戳
    timeLen: number  //倒计时（毫秒）
}

/**
 * 牛牛游戏下注信息
 */
export interface NiuniuBet {
    // 下注相关信息
    [key: string]: any;
}

/**
 * 牛牛游戏历史记录查询参数
 */
export interface NiuniuRoundHistoryParams {
    hallName: string;      // 厅名称
    page: number;          // 页码
    limit: number;         // 每页条数
}

/**
 * 牛牛游戏用户历史记录查询参数
 */
export interface NiuniuUserHistoryParams {
    userId: number;        // 用户ID
}

/**
 * 牛牛游戏退出参数接口
 */
export interface NiuniuExitParams {
    hallName: string;      // 大厅名称
}

/**
 * 牛牛游戏Socket API
 * @param rootPath Socket命名空间前缀，默认为'games'
 * @returns 牛牛游戏相关的Socket方法
 */
export const useNiuNiu = (rootPath = 'games') => {
    /**
     * 加入牛牛游戏房间
     * @param data 房间参数，包含hallName和rateType
     * @param callback 回调函数，处理服务器响应
     */
    const EMIT_NIUNIU_JOIN = (
        data: NiuniuJoinParams,
        callback: (res) => any,
    ) => {
        socket.emit(`${rootPath}.niuniu.join`, data, callback);
    };

    /**
     * 牛牛游戏下注
     * @param data 下注参数，包含下注金额和下注区域
     * @param callback 回调函数，处理服务器响应
     */
    const EMIT_NIUNIU_BET = (
        data: NiuniuBetParams,
        callback: (res) => any,
    ) => {
        socket.emit(`${rootPath}.niuniu.bet`, data, callback);
    };

    /**
     * 查询其他玩家下注
     * @param callback 
     * @returns closer 关闭器 
     */
    const ON_NIUNIU_BET = (callback:any) => {
        const sApi = `${rootPath}.niuniu.bet`;
        socket.on(sApi, callback);
        return () => socket.off(sApi, callback);
    };

    /**
     * 查询游戏状态
     * @param callback 
     * @returns closer 关闭器 
     */
    const ON_NIUNIU_STATE = (callback:any) => {
        const sApi = `${rootPath}.niuniu.state`;
        socket.on(sApi, callback);
        return () => socket.off(sApi, callback);
    };

    /**
     * 查询游戏结果
     * @param callback 
     * @returns closer 关闭器 
     */
    const ON_NIUNIU_RESULT = (callback:any) => {
        const sApi = `${rootPath}.niuniu.result`;
        socket.on(sApi, callback);
        return () => socket.off(sApi, callback);
    };

    /**
     * 获取牌牌游戏玩家列表
     * @param data 参数，包含allName
     * @param callback 回调函数，处理服务器响应
     */
    const EMIT_NIUNIU_USER_LIST = (
        data: NiuniuUserListParams,
        callback: (res) => any,
    ) => {
        socket.emit(`${rootPath}.niuniu.userList`, data, callback);
    };

    /**
     * 获取牛牛游戏历史记录
     * @param data 参数，包含hallName、page和limit
     * @param callback 回调函数，处理服务器响应
     */
    const EMIT_NIUNIU_ROUND_HISTORY = (
        data: NiuniuRoundHistoryParams,
        callback: (res) => any,
    ) => {
        socket.emit(`${rootPath}.niuniu.roundHistory`, data, callback);
    };

    /**
     * 获取牛牛游戏用户历史记录
     * @param data 参数，包含userId
     * @param callback 回调函数，处理服务器响应
     */
    const EMIT_NIUNIU_USER_HISTORY = (
        data: any,
        callback: (res) => any,
    ) => {
        socket.emit(`gamehistory.getHistory`, data, callback);
        // socket.emit(`${rootPath}.niuniu.userHistory`, data, callback);
    };

    /**
     * 退出牛牛游戏房间
     * @param data 参数，包含hallName
     * @param callback 回调函数，处理服务器响应
     */
    const EMIT_NIUNIU_EXIT = (
        data: NiuniuExitParams,
        callback: (res) => any,
    ) => {
        socket.emit(`${rootPath}.niuniu.exit`, data, callback);
    };

     /**
     * 撤销游戏下注
     * @param data 参数，包含hallName
     * @param callback 回调函数，处理服务器响应
     */
    const EMIT_NIUNIU_CANCEL = (
        data: any,
        callback: (res) => any,
    ) => {
        socket.emit(`${rootPath}.niuniu.cancel`, data, callback);
    };

      /**
     * 撤销游戏下注之后更新在线人数
     * @param data 参数，包含hallName
     * @param callback 回调函数，处理服务器响应
     */
    const ON_NIUNIU_CANCEL = (callback:any) => {
        const sApi = `${rootPath}.niuniu.cancel`;
        socket.on(sApi, callback);
        return () => socket.off(sApi, callback);
    };

    return {
        EMIT_NIUNIU_JOIN,
        EMIT_NIUNIU_BET,
        ON_NIUNIU_BET,
        ON_NIUNIU_STATE,
        ON_NIUNIU_RESULT,
        EMIT_NIUNIU_USER_LIST,
        EMIT_NIUNIU_ROUND_HISTORY,
        EMIT_NIUNIU_USER_HISTORY,
        EMIT_NIUNIU_EXIT,
        EMIT_NIUNIU_CANCEL,
        ON_NIUNIU_CANCEL,
    };
}